import { tokens, Typography } from "@sunrun/experience-ui-components";
import { useMemo } from "react";
import { ListOffer } from "../../../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import {
  CardItem,
  CardBreak,
  TwoColumnLayout,
  OfferCardHeader,
  OfferCardBody,
  // eslint-disable-next-line import/no-restricted-paths
} from "./OfferCardCommon";
import {
  formatNumber,
  formatPercent,
  formatProductCost,
  formatToOneDecimal,
} from "utils/formatHelpers";
import { financialProductDisplayText } from "constants/financialProducts";
import { DesignImagesData } from "hooks/useStorefrontDesignImages";

const IncludingFlex = () => {
  return (
    <Typography
      size="small"
      color={tokens.TINTS_OFF_WHITE_20}
      style={{ marginTop: 4 }}
    >{`Including ${financialProductDisplayText["FlexMonthly"]}`}</Typography>
  );
};

const SolarContent = ({
  designImages,
  offer,
  financing,
}: {
  designImages: { data?: DesignImagesData };
  offer: ListOffer;
  financing: string;
}) => {
  const isFlex = useMemo(() => {
    return offer.financing === "FlexMonthly";
  }, [offer]);
  return (
    <>
      <OfferCardHeader
        data-testid="solar-content"
        designImage={designImages?.data?.smallImageUrl}
      >
        <Typography
          size={24}
          lineHeight={24}
          fontWeight="regular"
          color="white"
        >
          {offer.label}
        </Typography>
      </OfferCardHeader>
      <OfferCardBody>
        <TwoColumnLayout>
          <CardItem title="Financing" value={financing} testId="financing" />
          {offer.payment && (
            <CardItem
              title="Payment amount"
              value={formatProductCost(offer.payment, offer.financing)}
              testId="payment-amount"
            />
          )}
          <CardItem title="Bundle" value={offer.bundleName} testId="bundle" />
          <CardItem
            title="Annual usage offset"
            value={formatPercent((offer.usageOffset ?? 0) / 100, 0)}
            testId="usage-offset-value"
            children={isFlex && <IncludingFlex />}
          />
          <CardItem
            title="Exp. annual prod"
            value={`${formatNumber(offer.production || 0)} kWh`}
            testId="production-value"
            children={isFlex && <IncludingFlex />}
          />
          <CardItem
            title="Panels"
            value={offer.solarCount ?? 0}
            testId="panels-value"
          />
          {offer?.usableCapacityKwh && (
            <CardItem
              title="Storage capacity"
              value={formatToOneDecimal(offer.usableCapacityKwh) + " kWh"}
              testId="storage-capacity"
            />
          )}
        </TwoColumnLayout>
        <CardBreak />
        <TwoColumnLayout>
          {offer.products.map((product, index) => {
            return (
              <CardItem
                title={product.name}
                value={product.count}
                testId={product.name}
                key={product.name}
              />
            );
          })}
        </TwoColumnLayout>
      </OfferCardBody>
    </>
  );
};

export { SolarContent };
